module.exports = __webpack_public_path__ + "assets/img/playsoundc.956448ea.gif";